import React, { useEffect, useState } from "react";
import { Layout } from "antd";
// import useStore from "../../../store";
import { Outlet, useNavigate } from "react-router-dom";
import HeaderComponent from "./components/HeaderComponent";
import SidebarComponent from "./components/SidebarComponent";
import { CONSTANT } from "../../../config/Constant";
import { useDispatch, useSelector } from "react-redux";
import {
  refreshTokenApi,
  setIsRefreshingToken,
  setIsUnauthorise,
} from "../../../features/auth/authSlice";
import { processFailedApiQueue } from "../../../features/auth/interceptorSlice";
import { resetStore } from "../../../features/auth/apiService";
import RestrictedAccessPage from "../../../components/RestrictedAccessPage";

const MainLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { token, isUnauthorise, isRestricted } = useSelector(
    (state) => state.auth
  );

  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    if (!token) {
      navigate(CONSTANT.LOGIN_REDIRECT_PATH);
    }
  }, [token, navigate]);

  useEffect(() => {
    if (isUnauthorise) {
      dispatch(refreshTokenApi())
        .unwrap()
        .then((token) => {
          processFailedApiQueue(null, token);
          dispatch(setIsUnauthorise(false));
          dispatch(setIsRefreshingToken(false));
        })
        .catch(() => {
          resetStore();
        });
    }
  }, [isUnauthorise, dispatch]);

  return (
    <Layout className={`main__page__content`}>
      <SidebarComponent collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout className="site-layout">
        <Layout.Header>
          <HeaderComponent collapsed={collapsed} setCollapsed={setCollapsed} />
        </Layout.Header>
        <Layout.Content className="main__app__content">
          {isRestricted ? <RestrictedAccessPage /> : <Outlet />}
        </Layout.Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
